import { flattenOpenSearchPaths, type OpenSearchPathOption } from "./flattenOpenSearchPaths";
import { getValueAtPath } from "./resolveDecorationBindings";

export function arrayResultPathOptions(root: unknown): OpenSearchPathOption[] {
  return flattenOpenSearchPaths(root).filter((option) => option.valueType === "array" && option.path);
}

export function itemFieldPathOptions(root: unknown, resultPath: string): OpenSearchPathOption[] {
  const rows = getValueAtPath(root, resultPath);
  if (!Array.isArray(rows) || rows.length === 0) {
    return [];
  }
  return flattenOpenSearchPaths(rows[0]).filter((option) => option.path);
}
